module.exports = __webpack_public_path__ + "img/track.25c19486.png";